module.exports = __webpack_public_path__ + "media/images/logo/zorg_ab-6ce61d812af1ef9ecf3dff26c1a073ce.jpg";